import React from 'react';
import PropTypes from 'prop-types';
import CSS from './PdxToggleSwitch.module.css';

const PdxToggleSwitch = ({
  id,
  label,
  checked,
  onChange
}) => (
  <div className={CSS.switchWrapper}>
    {label && <div className={CSS.label}>{label}</div>}
    <label htmlFor={id} className={CSS.switch}>
      <input
        type="checkbox"
        id={id}
        aria-labelledby={label}
        onChange={onChange}
        defaultChecked={checked}
      />
      <span className={CSS.slider} />
    </label>
  </div>
);

PdxToggleSwitch.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func
};

PdxToggleSwitch.defaultProps = {
  label: undefined,
  checked: false,
  onChange: undefined
};

export default PdxToggleSwitch;
